import React from "react";
import CreditCardForm from "./components/CreditCardForm";

function App() {
  return (
    <div className='App'>
      <CreditCardForm />
    </div>
  );
}

export default App;
